import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';

// MOS-2A-UX Stage 1 AUTOTEST G4 G2 RUM substrate per Q-G4-2 ratified
// (Option α — POST /api/telemetry/web-vitals + TimescaleDB + Grafana).
//
// V1 master-platform: PUBLIC endpoint (no auth) — first public route in the
// /api/telemetry/* family. PHASE-3C-PIVOT to authenticated at MOS-1U with
// session-cookie tenant_id binding. FW.42 carry: rate-limiting via nginx
// at ratchet trigger (≥10 req/sec sustained OR public launch OR MOS-1U pivot).
//
// 100% sampling at V1 per Q-G4-6 (low traffic; ratchet at Stage 9 PERF if
// traffic scales). web-vitals library handles its own batching + survives
// page unload via sendBeacon canonical.

function ship(metric: Metric): void {
  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    id: metric.id,
    rating: metric.rating,
    delta: metric.delta,
    navigation_type: metric.navigationType,
    page_url: window.location.pathname,
    timestamp_ms: Date.now(),
  });
  const url = '/api/telemetry/web-vitals';
  // sendBeacon canonical: survives `beforeunload`; fire-and-forget; no Promise.
  // Wrap body in a Blob with explicit `application/json` MIME so the server's
  // express.json() middleware parses it (raw string defaults to text/plain).
  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
    return;
  }
  // Fallback for environments without sendBeacon (older browsers; SSR).
  fetch(url, {
    method: 'POST',
    body,
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
  }).catch(() => {
    /* substrate-honest — telemetry loss acceptable; client-side gracefully degrades */
  });
}

export function instrumentWebVitals(): void {
  onLCP(ship);
  onINP(ship);
  onCLS(ship);
}
